import { ICON_SIZE } from '@components/v2/constants';
import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import {
  AMOUNTS_CONVERSION_GAP_SPACING,
  PERCENT_LABEL_MAX_WIDTH,
  PROGRESS_GAP_SPACING,
} from './orderTargets.constants';

export const getConversionColumnStyle = (theme: Theme) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  minWidth: `calc(${PERCENT_LABEL_MAX_WIDTH}px + ${theme.spacing(PROGRESS_GAP_SPACING)} + ${ICON_SIZE.md}px)`,
});

const useOrderTargetsStyles = makeStyles()((theme) => ({
  root: {
    border: `1px solid ${theme.palette.custom.border.primary}`,
    borderRadius: theme.shape.borderRadius,
    overflow: 'hidden',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(1),
    padding: theme.spacing(1, 1.5),
    cursor: 'pointer',
    '&:focus-visible': {
      outline: `2px solid ${theme.palette.primary.main}`,
      outlineOffset: -2,
    },
  },
  collapsedHeader: {
    '@media (hover: hover) and (pointer: fine)': {
      '&:hover': {
        backgroundColor: theme.palette.action.hover,
      },
    },
  },
  trimmedText: {
    textBox: 'trim-both cap alphabetic',
  },
  headerSummary: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(AMOUNTS_CONVERSION_GAP_SPACING),
  },
  conversion: getConversionColumnStyle(theme),
  bodyWithoutFooter: {
    paddingBottom: theme.spacing(1),
  },
  footer: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: theme.spacing(1, 1.5),
  },
}));

export default useOrderTargetsStyles;
